<template>
  <div id="app">
    <div class="top-nav-bar" v-if="!hideHeader">
      <!-- <b-row>
          <b-col style="margin-left:10px">
              <img src="@/assets/ui-design_02.jpg" style="width: 300px;" />
          </b-col>
          <b-col style="text-align:right">
              <img  src="@/assets/lion.jpg" />
          </b-col>
      </b-row>-->

      <!-- top header nav starts here -->
      <div class="container">
        <!-- <p id="top-text">महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</p> -->
        <div id="top-nav-header">
          <div class="row no-gutters">
            <b-col cols="6" lg="2" md="3">
              <div class="logo-box-wrapper">
                <div class="logo-box">
                  <img src="@/assets/images/satyamev-jayate.png" class="img-1" />

                </div>
                <!-- logo box ends -->

                <div class="logo-box1">
                  <img src="@/assets/images/header4.png"  class="img-1" />
                </div>
                <!-- logo box -->
              </div>
              <!-- logo-box-wrapper ends -->
            </b-col>
            <!-- col-->
            <b-col cols="8" lg="8" md="6" style="text-align:center" class="marathi header-text d-none d-md-block">
              <!-- <h6>इतर मागास बहुजन कल्याण विभाग</h6> -->
              <h6 style="color: royalblue; font-weight: bold; font-size: 25px;">राजे उमाजी नाईक आर्थिक विकास महामंडळ</h6>

              <!-- <h6 class="heading-marathi-2">Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)  </h6> -->
              <h6 style="color: royalblue; text-shadow: 0 1px 1px #000;">इतर मागास बहुजन कल्याण विभाग</h6>

            </b-col>
            <b-col cols="6" lg="2" md="3" style="text-align:right">
              <div class="logo-box-wrapper">
                <div class="logo-box">
                  <img src="@/assets/images/top_image2.png"  class="img-logo"/>
                </div>
                <!-- logo box -->
              </div>
              <!-- logo-box-wrapper ends -->
            </b-col>
          </div>

         <!-- row ends-->

         <p class="text-sm marathi">राजे उमाजी नाईक आर्थिक विकास महामंडळ</p>
        </div>
        <!-- top-nav-header ends here -->
      </div>

      <!-- top header nav ends here -->

      <RegistrationNavbar v-if="isLoggedIn"></RegistrationNavbar>
      <!-- <b-navbar toggleable="md" type="dark" class="navbar navbar-light bg-info" v-if="isLoggedIn">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <b-nav-item to="/dashboard">Home</b-nav-item>
            <b-nav-item-dropdown text="My Account" v-if="RegType<11">
              <b-dropdown-item to="/profile"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></b-dropdown-item>
              <b-dropdown-item to="/viewapp"><i class="fa fa-desktop"></i> <span>View Application</span></b-dropdown-item>
              <b-dropdown-item to="/results"><i class="fa fa-star"></i> <span>View Result</span></b-dropdown-item>
              <b-dropdown-item to="/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></b-dropdown-item>
              <b-dropdown-item to="/letter"><i class="fa fa-envelope"></i> <span>Intimation Letter</span></b-dropdown-item>
              <b-dropdown-item to="#"><i class="fa fa-envelope"></i> <span>B-Form</span></b-dropdown-item>

            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="My Account" v-if="RegType==11">
              <b-dropdown-item to="/registrations"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></b-dropdown-item>
              <b-dropdown-item to="/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></b-dropdown-item>
              <b-dropdown-item to="/employerprofile"><i class="fa fa-credit-card"></i> <span>Print Profile</span></b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="My Account" v-if="RegType==12">
              <b-dropdown-item to="/registrations"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></b-dropdown-item>
              <b-dropdown-item to="/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></b-dropdown-item>
              <b-dropdown-item to="/guardprofile"><i class="fa fa-credit-card"></i> <span>Print Profile</span></b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="My Account" v-if="RegType==13">
              <b-dropdown-item to="/agencyregistration"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></b-dropdown-item>
              <b-dropdown-item to="#"><i class="fa fa-pencil-alt"></i> <span>Registered Employers</span></b-dropdown-item>
              <b-dropdown-item to="#"><i class="fa fa-pencil-alt"></i> <span>Guards Registered with Agency</span></b-dropdown-item>
              <b-dropdown-item to="/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></b-dropdown-item>
              <b-dropdown-item to="#"><i class="fa fa-credit-card"></i> <span>Application for Exemption</span></b-dropdown-item>
              <b-dropdown-item to="/agencyprofile"><i class="fa fa-credit-card"></i> <span>Print Profile</span></b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
        <b-navbar-brand href="#" class="ml-auto">Welcome, {{username}}</b-navbar-brand>
        <b-navbar-nav>
            <b-nav-item-dropdown text="English" class="lang-bar">
                <b-dropdown-item @click="setLang('en', 'English')">English</b-dropdown-item>
                <b-dropdown-item @click="setLang('mr','मराठी')">मराठी</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto mr-2">
          <b-nav-item href="#" @click="logout">Logout</b-nav-item>
        </b-navbar-nav>
      </b-navbar>-->
    </div>
    <router-view />


    <!-- <div class="footer-main">

      <b-nav class="">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/terms">Terms &amp; Conditions</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/privacy">Privacy</a>
          </li>

        </ul>
      </b-nav>
    </div> -->
  </div>
</template>

<script>
import RegistrationNavbar from "@/components/RegistrationNavbar";
export default {
  components: { RegistrationNavbar },
  name: "App",
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
    login() {
      this.$router.replace("/");
    },
    setLanguage() {
      var temp_lang = document.getElementsByClassName("goog-te-combo")[0].value;
      var flang =
        temp_lang == "hi" ? "हिन्दी" : temp_lang == "mr" ? "मराठी" : "English";

      document.querySelector(".lang-bar a.dropdown-toggle").innerHTML = flang;
    }
  },
  computed: {
    hideHeader() {
      return this.$route.meta.hideHeader;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.UserName;
    },
    RegType() {
      var nme = this.$store.getters.loggedUser;
      return nme.RegistrationType;
    }
  }
};
</script>

<style>
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  background: #e8eff9;
}

ul {
  padding: 0;
  margin: 0;
}
.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}
.navbar {
  padding: 0 !important;
  background: #5c6bc0 !important;
}
.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}
.navbar-toggler {
  margin: 5px;
}
.container.sm {
  width: 90% !important;
  background: #0A0032;
  padding: 20px 10px;
}
/* #google_translate_element,
.skiptranslate {
  display: none;
} */

body {
  top: 0 !important;
}

@import url("https://fonts.googleapis.com/css?family=Laila&display=swap");

.marathi {
  font-family: "Laila", serif;
}

.header-text h6 {
  font-weight: 400;
  margin-bottom: 5px;
  font-size: 16px;
}

.heading-marathi-2 {
  margin-top: 10px;
  color: royalblue;
  font-weight: bold;
}

.header-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* UI changes by Akshay 19-08-2019 */
.top-nav-bar {
  /* background-color:#ec5624; */
  background-color:#fff;
  background-image: url("assets/images/circles.png");
}

#top-text {
  font-size: 15px;
  text-align: center;
  padding-top: 7px;
  color: #fff;
}

#top-nav-header {
  color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
}

#top-nav-header .logo-box-wrapper {
  display: flex;
  width: fit-content;
  margin-top: 25px;
  margin-left: auto;
  margin-right: auto;
}

#top-nav-header .logo-box {
  max-width: 200px;
  max-height: 200px;
  padding-left: 15px;
  padding-right: 15px;
  display: -webkit-flex; /* Safari */
  -webkit-align-items: center; /* Safari 7.0+ */
  display: flex;
  align-items: left;
}

#top-nav-header .logo-box img {
  max-width: 90px;
  max-height: 90px;
}
#top-nav-header .logo-box1 img {
  max-width: 90px;
  max-height: 90px;
}

#top-nav-header .photo-box-wrap {
  display: -webkit-flex; /* Safari */

  display: flex;
  margin-top: 16px;
  padding-right: 5px;
}

#top-nav-header .photo-box {
  min-width: 40px;
  min-height: 40px;

  margin-right: 10px;
  max-height: 40px;
  max-width: 40px;
}

#top-nav-header .photo-box img {
  max-width: 100%;
  max-height: 100%;

  border: 2px solid #f3ff08;
}

#top-nav-header .content-box {
  height: fit-content;
}

#top-nav-header .photo-box-wrap .content-box h5 {
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
  color: #f3ff08;
  font-weight: bold;
}

#top-nav-header .photo-box-wrap .content-box p {
  font-size: 12px;
  line-height: 1.4;
  color: #fff;
}

#top-nav-header .logo-box-wrapper img.img-1 {
  height: 90px;
}

/* responsive styles */

@media (max-width: 1199px) {
  #top-nav-header .photo-box-wrap .content-box h5 {
    font-size: 12px;
  }

  #top-nav-header .photo-box-wrap .content-box p {
    font-size: 10px;
  }
}

@media (max-width: 991px) {
  #top-nav-header .hide-tab {
    display: none;
  }
}

@media (max-width: 767px) {
  #top-text {
    text-align: left;
    font-size: 14px;
  }
}

@media (max-width: 575px) {
  #top-text {
    padding-top: 32px;
    text-align: center;
  }
}

.footer-main {
  margin-top: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #5c6bc0;
  text-align: right;
  bottom: 0;
  width: 100%;
}

.footer-main ul {
  width: fit-content;
  margin: auto;
}

.text-sm {
  display: none;
}

@media (max-width: 767px) {
  .text-sm {
    display: block;
    color: #fff;
    text-align: center;
    font-size: 15px;
    margin-top: 5px;
  }

  #top-nav-header .logo-box img {
    max-width: 75px;
    max-height: 75px;
  }
}

@media (max-width: 419px) {
  .text-sm {
    font-size: 14px;
    line-height: 1.4;
  }

  #top-nav-header .logo-box img {
    max-width: 65px;
    max-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue